import $ from "jquery";
import Cookies from "js-cookie";

const $cookiesEl = $(".cookies");
const $cookiesBar = $(".cookies__bar");
const $cookiesConsent = $(".cookies__consent");
const $cookiesDecline = $(".cookies__decline");
const $cookiesConsentAll = $(".cookies__consent_all");
const $cookiesConsentCustom = $(".cookies__consent_custom");

const cookie_cnsnt = Cookies.get("cookie_cnsnt");

const acknowledgeCookies = (all = false) => {
  let categories = [];

  if (all === true) {
    $cookiesEl.find(".checkbox-switch__input").each(function () {
      categories.push($(this).data("category"));
    });
  } else {
    $cookiesEl.find(".checkbox-switch__input:checked").each(function () {
      categories.push($(this).data("category"));
    });
  }

  categories = categories.join(",");
  Cookies.set("cookie_cnsnt", categories, { expires: 90 });

  initCookieFunctions(categories);
};

const initCookieFunctions = (cookie_cnsnt) => {
  const categories = cookie_cnsnt.split(",");

  categories.forEach(function (category) {
    switch (category) {
      case "analytics":
        initGoogleAnalytics();
        break;
    }
  });

  if (!categories.includes("analytics")) {
    disableGoogleAnalytics();
  }
};

const initGoogleAnalytics = () => {
  $cookiesEl.find(`[data-category=analytics]`).prop("checked", true);

  gtag("consent", "update", {
    analytics_storage: "granted",
  });
};

function disableGoogleAnalytics() {
  gtag("consent", "update", {
    analytics_storage: "denied",
  });
}

function gtag() {
  dataLayer.push(arguments);
}

cookie_cnsnt === undefined
  ? $cookiesBar.slideUp(0).slideDown(300).addClass("active")
  : initCookieFunctions(cookie_cnsnt);

$cookiesConsent.on("click", function () {
  acknowledgeCookies(true);
  $cookiesBar.removeClass("active").slideUp(300);
});
$cookiesConsentAll.on("click", function () {
  acknowledgeCookies(true);
  $cookiesBar.removeClass("active").slideUp(300);
});
$cookiesConsentCustom.on("click", function () {
  acknowledgeCookies();
  $cookiesBar.removeClass("active").slideUp(300);
});
$cookiesDecline.on("click", function () {
  Cookies.set("cookie_cnsnt", "required", { expires: 90 });
  $cookiesBar.slideUp();
});
